/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Friends = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Friends"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <circle
        cx={15.333}
        cy={8.667}
        r={6.667}
        fill="#F5D6EB"
        className="Fill-Accent"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M14.222 7A1.111 1.111 0 1 1 12 7a1.111 1.111 0 0 1 2.222 0m-2.812 3.3a.833.833 0 0 1 1.18 0 3.88 3.88 0 0 0 5.488 0 .833.833 0 1 1 1.178 1.178 5.547 5.547 0 0 1-7.845 0 .833.833 0 0 1 0-1.178m6.145-2.189a1.111 1.111 0 1 0 0-2.222 1.111 1.111 0 0 0 0 2.222"
        className="Fill-Secondary"
      />
      <circle
        cx={8.667}
        cy={15.333}
        r={6.667}
        fill="#FFC220"
        className="Fill-Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M7.556 13.667a1.111 1.111 0 1 1-2.223 0 1.111 1.111 0 0 1 2.223 0m-2.812 3.299a.833.833 0 0 1 1.179 0 3.88 3.88 0 0 0 5.488 0 .834.834 0 0 1 1.178 1.179 5.547 5.547 0 0 1-7.845 0 .833.833 0 0 1 0-1.179m6.145-2.188a1.111 1.111 0 1 0 0-2.222 1.111 1.111 0 0 0 0 2.222"
        className="Fill-Secondary"
      />
    </g>
  </svg>
);

export const FriendsIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'friends-icon'}
      icon={Friends}
      {...props}
      size={size}
    />
  );
};
